import { DeleteIcon, EditIcon, ResourceMenuActions, type ResourceMenuItem } from '@all-manager/design-system-v2';
import ConfirmDeleteDialog from '../../../../../components/ConfirmDeleteDialog/ConfirmDeleteDialog';
import type { SubjectTaskDatabase } from '../../../../../types';
import { useTaskMenuActions } from './useTaskMenuActions';

// Keeps the French quotes and question mark on the title's line.
const NBSP = '\u00a0';

type Props = {
  task: SubjectTaskDatabase;
  onEdit: () => void;
  onDelete: () => void | Promise<unknown>;
};

export default function TaskMenuActions(props: Props) {
  const hook = useTaskMenuActions(props);

  const actions: (ResourceMenuItem | null | undefined | false)[] = [
    {
      id: 'edit',
      label: 'Modifier',
      icon: <EditIcon fontSize="small" />,
      onClick: hook.handleEditClick,
    },
    { type: 'divider', id: 'divider' },
    {
      id: 'delete',
      label: 'Supprimer',
      icon: <DeleteIcon fontSize="small" color="error" />,
      onClick: hook.handleDeleteClick,
    },
  ];

  return (
    <>
      <ResourceMenuActions actions={actions} tooltip={`Options de la tâche ${props.task.title}`} />

      {hook.isDeleteModalOpen ? (
        <ConfirmDeleteDialog
          title="Supprimer la tâche"
          onConfirm={hook.handleConfirmDelete}
          onClose={hook.handleDeleteModalClose}
        >
          Supprimer la tâche «{NBSP}{props.task.title}{NBSP}»{NBSP}?
        </ConfirmDeleteDialog>
      ) : null}
    </>
  );
}

export { TaskMenuActions };
